import { useQueryParams } from 'use-query-params'

import { useNLUDataStore } from '../../../../../../stores/nluDataStore'
import { DashArrayParam } from '../../../../../../utils/useQueryParams'
import { NLUFilterCategoryEnum } from '../NLUFilters'

import styles from './nlu-filters-options.module.scss'

interface INLUFilterCategoryProps {
    category: NLUFilterCategoryEnum
}

function NLUFiltersOptions(props: INLUFilterCategoryProps) {
    const { category } = props

    const [query, setQuery] = useQueryParams({
        [NLUFilterCategoryEnum.ENTITIES]: DashArrayParam,
        [NLUFilterCategoryEnum.INTENTS]: DashArrayParam,
    })

    const [state] = useNLUDataStore()
    const options = state[category]
    const selectedOptions = query[category] as string[]

    const handleOptionChange = (option: string) => {
        const clonedSelectedOptions = structuredClone(selectedOptions) || []

        if (clonedSelectedOptions.includes(option)) {
            const index = clonedSelectedOptions.indexOf(option)
            clonedSelectedOptions.splice(index, 1)
            setQuery({
                [category]: clonedSelectedOptions.length
                    ? clonedSelectedOptions
                    : null,
            })
            return
        }

        clonedSelectedOptions?.push(option)
        setQuery({ [category]: clonedSelectedOptions })
    }

    return (
        <div className={styles.nluFiltersOptions}>
            {options.map((option: string) => (
                <label key={option} className={styles.nluFiltersOptions__label}>
                    <input
                        type="checkbox"
                        checked={selectedOptions?.includes(option)}
                        onChange={() => handleOptionChange(option)}
                    />
                    {option}
                </label>
            ))}
        </div>
    )
}

export default NLUFiltersOptions
